import {
  GET_LIST_PROMO_GROUP_REQUEST,
  GET_LIST_PROMO_GROUP_SUCCESS,
  GET_LIST_PROMO_GROUP_FAIL,
  DELETE_PROMO_GROUP_REQUEST,
  DELETE_PROMO_GROUP_SUCCESS,
  DELETE_PROMO_GROUP_FAIL,
  CREATE_PROMO_GROUP_REQUEST,
  CREATE_PROMO_GROUP_SUCCESS,
  CREATE_PROMO_GROUP_FAIL,
  GET_DETAIL_PROMO_GROUP_REQUEST,
  GET_DETAIL_PROMO_GROUP_SUCCESS,
  GET_DETAIL_PROMO_GROUP_FAIL,
  UPDATE_PROMO_GROUP_REQUEST,
  UPDATE_PROMO_GROUP_SUCCESS,
  UPDATE_PROMO_GROUP_FAIL,
  GET_PROMO_GROUP_TRANSACTIONS_REQUEST,
  GET_PROMO_GROUP_TRANSACTIONS_SUCCESS,
  GET_PROMO_GROUP_TRANSACTIONS_FAIL,
  EXPORT_PROMO_GROUP_REQUEST,
  EXPORT_PROMO_GROUP_SUCCESS,
  EXPORT_PROMO_GROUP_FAIL,
  GET_LIST_EXPORT_PROMO_GROUP_REQUEST,
  GET_LIST_EXPORT_PROMO_GROUP_SUCCESS,
  GET_LIST_EXPORT_PROMO_GROUP_FAIL,
  DOWNLOAD_EXPORT_PROMO_GROUP_REQUEST,
  DOWNLOAD_EXPORT_PROMO_GROUP_SUCCESS,
  DOWNLOAD_EXPORT_PROMO_GROUP_FAIL
} from '../../constants/promo-groups'

const initialState = {
  loading: false,
  loadingCrud: false,
  promoGroupList: [],
  promoGroupDetail: {},
  pageable: {
    page: 1,
    size: 10,
    hits: 1
  },
  promoGroupTransactions: [],
  transactionPageable: {
    page: 1,
    size: 10,
    hits: 0
  },
  loadingTransactions: false,
  promoGroupExportList: [],
  pageableExport: {
    page: 1,
    size: 10,
    hits: 0
  },
  loadingDownload: false,
  error: null
}

const promoGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_PROMO_GROUP_REQUEST:
      return { ...state, loading: true }
    case GET_LIST_PROMO_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        promoGroupList: action.payload,
        pageable: action.pageable
      }
    case GET_LIST_PROMO_GROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        promoGroupList: [],
        pageable: {
          page: 1,
          size: 10
        }
      }
    case DELETE_PROMO_GROUP_REQUEST:
    case CREATE_PROMO_GROUP_REQUEST:
    case UPDATE_PROMO_GROUP_REQUEST:
      return { ...state, loadingCrud: true }
    case DELETE_PROMO_GROUP_SUCCESS:
    case CREATE_PROMO_GROUP_SUCCESS:
    case UPDATE_PROMO_GROUP_SUCCESS:
      return { ...state, loadingCrud: false }
    case DELETE_PROMO_GROUP_FAIL:
    case CREATE_PROMO_GROUP_FAIL:
    case UPDATE_PROMO_GROUP_FAIL:
      return { ...state, loadingCrud: false, error: action.payload }
    case GET_DETAIL_PROMO_GROUP_REQUEST:
      return { ...state, loading: true, error: false }
    case GET_DETAIL_PROMO_GROUP_SUCCESS:
      return { ...state, loading: false, promoGroupDetail: action.payload, error: false }
    case GET_DETAIL_PROMO_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload }
    case GET_PROMO_GROUP_TRANSACTIONS_REQUEST:
      return { ...state, loadingTransactions: true }
    case GET_PROMO_GROUP_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loadingTransactions: false,
        promoGroupTransactions: action.payload,
        transactionPageable: action.pageable
      }
    case GET_PROMO_GROUP_TRANSACTIONS_FAIL:
      return {
        ...state,
        loadingTransactions: false,
        promoGroupTransactions: [],
        error: action.payload
      }
    case EXPORT_PROMO_GROUP_REQUEST:
      return { ...state, loadingCrud: true }
    case EXPORT_PROMO_GROUP_SUCCESS:
      return { ...state, loadingCrud: false }
    case EXPORT_PROMO_GROUP_FAIL:
      return { ...state, loadingCrud: false, error: action.payload }
    case GET_LIST_EXPORT_PROMO_GROUP_REQUEST:
      return { ...state, loading: true }
    case GET_LIST_EXPORT_PROMO_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        promoGroupExportList: action.payload,
        pageableExport: action.pageable
      }
    case GET_LIST_EXPORT_PROMO_GROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        promoGroupExportList: [],
        pageableExport: {
          page: 1,
          size: 10
        }
      }
    case DOWNLOAD_EXPORT_PROMO_GROUP_REQUEST:
      return { ...state, loadingDownload: true }
    case DOWNLOAD_EXPORT_PROMO_GROUP_SUCCESS:
      return { ...state, loadingDownload: false }
    case DOWNLOAD_EXPORT_PROMO_GROUP_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default promoGroupsReducer
